import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { merge } from "@modern-js/runtime-utils/merge";
function initPluginAPI(param) {
  var context = param.context, plugins = param.plugins;
  var hooks = context.hooks, extendsHooks = context.extendsHooks;
  function getRuntimeContext() {
    if (context) {
      var hooks2 = context.hooks, extendsHooks2 = context.extendsHooks, config = context.config, pluginAPI2 = context.pluginAPI, runtimeContext = _object_without_properties(context, [
        "hooks",
        "extendsHooks",
        "config",
        "pluginAPI"
      ]);
      runtimeContext._internalContext = context;
      return runtimeContext;
    }
    throw new Error("Cannot access context");
  }
  function updateRuntimeContext(updateContext) {
    context = merge(context, updateContext);
  }
  function getHooks() {
    return _object_spread({}, hooks, extendsHooks);
  }
  function getRuntimeConfig() {
    if (context.config) {
      return context.config;
    }
    throw new Error("Cannot access config");
  }
  var extendsPluginApi = {};
  plugins.forEach(function(plugin) {
    var _registryApi = plugin._registryApi;
    if (_registryApi) {
      var apis = _registryApi(getRuntimeContext, updateRuntimeContext);
      Object.keys(apis).forEach(function(apiName) {
        extendsPluginApi[apiName] = apis[apiName];
      });
    }
  });
  if (extendsHooks) {
    Object.keys(extendsHooks).forEach(function(hookName) {
      extendsPluginApi[hookName] = extendsHooks[hookName].tap;
    });
  }
  var pluginAPI = _object_spread({
    updateRuntimeContext,
    getHooks,
    getRuntimeConfig,
    config: hooks.config.tap,
    onBeforeRender: hooks.onBeforeRender.tap,
    wrapRoot: hooks.wrapRoot.tap,
    pickContext: hooks.pickContext.tap
  }, extendsPluginApi);
  if (typeof Proxy === "undefined") {
    return pluginAPI;
  }
  return new Proxy(pluginAPI, {
    get: function get(target, prop) {
      if (prop === "then") {
        return void 0;
      }
      if (prop in target) {
        return target[prop];
      }
      return function() {
        console.warn("api.".concat(prop.toString(), " not exist"));
      };
    }
  });
}
export {
  initPluginAPI
};
